/**
 * Review Management-specific translation keys
 */
export const review = {
  list: {
    main_heading: "admin.review_list_heading",
    search_placeholder: "admin.review_search_placeholder",
    table: {
      reviewer_name_col_heading: "admin.review_table_reviewer_name_col_heading",
      freelancer_name_col_heading: "admin.review_table_freelancer_name_col_heading",
      rating_col_heading: "admin.review_table_rating_col_heading",
      comment_col_heading: "admin.review_table_comment_col_heading",
      review_date_col_heading: "admin.review_table_review_date_col_heading",
      reply_col_heading: "admin.review_table_reply_col_heading",
      actions_col_heading: "admin.review_table_actions_col_heading",
    },
    freelancer_filter_placeholder: "admin.review_freelancer_filter_placeholder",
    reviewer_filter_placeholder: "admin.review_reviewer_filter_placeholder",
    rating_filter_placeholder: "admin.review_rating_filter_placeholder",
    start_date_label: "admin.review_start_date_label",
    end_date_label: "admin.review_end_date_label",
    clear_filter_btn_text: "admin.review_clear_filter_btn_text",
    reply_yes: "admin.review_reply_yes",
    reply_no: "admin.review_reply_no",
    action_tooltip: {
      view: "admin.review_action_tooltip_view",
      delete: "admin.review_action_tooltip_delete",
    },
    delete_popup: {
      heading: "admin.review_delete_popup_heading",
      message: "admin.review_delete_popup_message",
      message_2: "admin.review_delete_popup_message_2",
      yes_btn_text: "admin.review_delete_popup_yes_btn_text",
      no_btn_text: "admin.review_delete_popup_no_btn_text",
    },
    messages: {
      fetch_failed: "admin.review_messages_fetch_failed",
      delete_success: "admin.review_messages_delete_success",
      delete_failed: "admin.review_messages_delete_failed",
    },
    defaults: {
      na: "admin.review_defaults_na",
    },
  },
  view: {
    main_heading: "admin.review_view_heading",
    back_to_list: "admin.review_back_to_list",
    error: {
      not_found: "admin.review_not_found_heading",
      not_found_description: "admin.review_not_found_description",
    },
    reviewer_section: {
      title: "admin.review_view_reviewer_section_title",
      name_label: "admin.review_view_reviewer_name_label",
      username_label: "admin.review_view_reviewer_username_label",
      email_label: "admin.review_view_reviewer_email_label",
    },
    freelancer_section: {
      title: "admin.review_view_freelancer_section_title",
      business_name_label: "admin.review_view_freelancer_business_name_label",
      account_holder_label: "admin.review_view_freelancer_account_holder_label",
    },
    review_section: {
      title: "admin.review_view_review_section_title",
      rating_label: "admin.review_view_rating_label",
      comment_label: "admin.review_view_comment_label",
      review_date_label: "admin.review_view_review_date_label",
    },
    reply_section: {
      title: "admin.review_view_reply_section_title",
      no_reply: "admin.review_view_no_reply",
      replied_on_label: "admin.review_view_replied_on_label",
    },
    actions: {
      delete: "admin.review_view_delete_btn",
    },
    defaults: {
      na: "admin.review_view_defaults_na",
    },
  },
};
